import { CheckboxProps } from '@mui/material';
import { RadioProps } from '@mui/material/Radio';

const Constants = Object.freeze({
  DEFAULT_ID: 0,
  QUERY_KEYS: {
    FILES: 'files',
    LOCATIONS: 'locations',
    SITES: 'sites',
    REFINERS: 'refiners',
    ACCESS_TOKEN: 'accessToken',
    USER_NAME: 'userName',
    EXTERNAL_LINKS: 'externalLinks',
    QUICK_REFERENCES: 'quickReferences',
    ALERTS: 'alerts',
    RECENT_DOCUMENTS: 'recentDocuments',
    AUTH_SETTINGS: 'authSettings',
  },
  BASE_STYLES: {
    FILTER_ITEM_PROPS: {
      size: 'small',
    } as Partial<RadioProps | CheckboxProps>,
    FORM_CONTROL_LABEL_PROPS: {
      sx: {
        marginBottom: 0,
      },
    },
    ACCORDION_SUMMARY: {
      sx: {
        '&.Mui-expanded': {
          minHeight: '48px',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
          margin: '12px 0',
        },
      },
    },
    ACCORDION_DETAILS: {
      sx: {
        paddingLeft: 4,
        paddingTop: 0,
        paddingBottom: 1.5,
        maxHeight: 300,
        overflow: 'auto',
        marginRight: 2.4,
        marginBottom: 2.4,
      },
    },
  },
  BASE_DISABLE_REFETCH_SETTINGS: {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    cacheTime: 1000 * 60 * 60,
  },
  LOGOUT_REDIRECT_URI: `/.auth/logout?post_logout_redirect_uri=${window.location.origin}`,
  QUICK_REFERENCE_URL: `${window.location.origin}/api/WHCPortal/DownloadQuickReference/`,
  STATES: [
    { id: 'NSW', title: 'New South Wales' },
    { id: 'QLD', title: 'Queensland' },
  ],
  LOCAL_STORAGE_KEYS: {
    EXPIRATION_TIME: 'expirationTime',
    IS_SESSION_TIMED_OUT: 'isSessionTimedOut',
  },
});

export default Constants;
